import { useState } from 'react';
import { FaTimes } from 'react-icons/fa';
import '../styles/ItemModal.css';

const ItemModal = ({ item, onClose, onAddToCart }) => {
  const [selectedSize, setSelectedSize] = useState('');
  const [selectedColor, setSelectedColor] = useState('');

  if (!item) {
    return null;
  }

  const handleAddToCart = () => {
    if (!selectedSize || !selectedColor) {
      alert('Please select both size and color');
      return;
    }

    onAddToCart({
      ...item,
      size: selectedSize,
      color: selectedColor,
    });
    onClose();
  };

  return (
    <div className='item-modal-overlay' onClick={onClose}>
      <div className='item-modal' onClick={e => e.stopPropagation()}>
        <div className='item-modal-header'>
          <h2 className='item-modal-title'>{item.name}</h2>
          <button className='item-modal-close-btn' onClick={onClose}>
            <FaTimes />
          </button>
        </div>

        <div className='item-modal-content'>
          <div className='item-modal-grid'>
            <div className='modal-item-card'>
              <div className='modal-item-image'>
                <img 
                  src={item.image_url || '/assets/placeholder.jpg'} 
                  alt={item.name}
                  onError={e => {
                    e.target.src = '/assets/placeholder.jpg';
                  }}
                />
              </div>
              <div className='modal-item-info'>
                <h3 className='modal-item-name'>{item.name}</h3>
                <p className='modal-item-price'>${item.price?.toFixed(2) || '0.00'}</p>
              </div>
            </div>
          </div>

          <div className='modal-details'>
            <p className='description'>
              {item.description || 'A versatile and elegant piece perfect for any occasion.'}
            </p>

            {/* Size Selection */}
            {item.sizes && item.sizes.length > 0 && (
              <div className='size-selection'>
                <h3>Select Size:</h3>
                <div className='size-options'>
                  {item.sizes.map(size => (
                    <button
                      key={size}
                      className={`size-button ${selectedSize === size ? 'selected' : ''}`}
                      onClick={() => setSelectedSize(size)}
                    >
                      {size}
                    </button>
                  ))}
                </div>
              </div>
            )}

            {/* Color Selection */}
            {item.colors && item.colors.length > 0 && (
              <div className='color-selection'>
                <h3>Select Color:</h3>
                <div className='color-options'>
                  {item.colors.map(color => (
                    <button
                      key={color}
                      className={`color-button ${selectedColor === color ? 'selected' : ''}`}
                      style={{
                        backgroundColor: color.toLowerCase(),
                        border: color.toLowerCase() === 'white' ? '2px solid #ddd' : '2px solid transparent',
                      }}
                      onClick={() => setSelectedColor(color)}
                      title={color}
                    >
                      <span className='sr-only'>{color}</span>
                    </button>
                  ))}
                </div>
              </div>
            )}

            <div className='action-buttons'>
              <button className='add-to-cart' onClick={handleAddToCart}>
                Add to Cart
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ItemModal;
